import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { ContentSections } from '../components/ContentSections';
import { OfferDetails } from '../components/OfferDetails';
import { SocialProof } from '../components/SocialProof';
import { FAQSection } from '../components/FAQSection';
import { PricingCTA } from '../components/PricingCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
    // Small delay to ensure fbq is loaded before firing PageView
    const timer = setTimeout(() => {
      trackPageView();
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return <div className="min-h-screen bg-cream font-body text-text-dark" data-id="element-165">
      <HeroSection data-id="element-166" />
      <ContentSections data-id="element-167" />
      <OfferDetails data-id="element-168" />
      <SocialProof data-id="element-169" />
      <FAQSection data-id="element-170" />
      <PricingCTA data-id="element-171" />
      <Footer data-id="element-172" />
    </div>;
}